module.exports = __webpack_public_path__ + "static/img/8.bc5b9a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/8.png
// module id = Y9t1
// module chunks = 0